export const EGG_LABELS = {
  grande: 'Grandes',
  mediano: 'Medianos',
  pequeno: 'Pequeños',
  doble: 'Dobles',
  sucio: 'Sucios',
  casquiado: 'Casquiados',
};
